import socket from './socket';

const updatePointSystem = (projectId, data, headers) =>
  socket.patch(`/projects/${projectId}/point-system`, data, headers);

const updateBoardPointSystem = (boardId, data, headers) =>
  socket.patch(`/boards/${boardId}/point-system`, data, headers);

export default {
  updatePointSystem,
  updateBoardPointSystem,
};
